import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionsModalTypes } from '../../../../../core/legacy/reducers/modals';
import FailureModal from '../../../../legacy/components/ui/modals/FailureModal';

export const MlFailureModal: FC = () => {
    const { t } = useTranslation();

    return (
        <FailureModal
            title={t('run-ml.failure.title')}
            subtitle={t('run-ml.failure.subtitle')}
            modalType={SessionsModalTypes.SESSIONS_ML_FAILURE}
        />
    );
};
